export default {
    isRouteAccessible: function (profile: any, to: any) {      
      return profile.functions ? profile.functions.find((x: any) => x.routeName == to.name) : [];
    },
    isRouteNameAccessible: function (profile: any, toRouteName: any) {      
        return profile.functions ? profile.functions.find((x: any) => x.routeName == toRouteName) : [];
    }
}
